import { AccountQueryHandler, AccountTokenSnapshotLogQueryHandler, AccountTokenSnapshotQueryHandler, FlowOperatorQueryHandler, IndexQueryHandler, IndexSubscriptionQueryHandler, StreamPeriodQueryHandler, StreamQueryHandler, TokenQueryHandler, TokenStatisticLogQueryHandler, TokenStatisticQueryHandler, } from '@superfluid-finance/sdk-core';
import { getSubgraphClient } from '../../../../sdkReduxConfig';
import { createGeneralTags } from '../../cacheTags/CacheTagTypes';
import { CacheTime } from '../../cacheTime';
import { provideSpecificCacheTagsFromRelevantAddresses } from '../provideSpecificCacheTagsFromRelevantAddresses';
export const createEntityEndpoints = (builder) => {
    // NOTE: Ignoring prettier because longer lines are more readable here.
    // prettier-ignore
    return {
        account: get(builder, new AccountQueryHandler()),
        accounts: list(builder, new AccountQueryHandler()),
        accountTokenSnapshot: get(builder, new AccountTokenSnapshotQueryHandler()),
        accountTokenSnapshots: list(builder, new AccountTokenSnapshotQueryHandler()),
        accountTokenSnapshotLog: get(builder, new AccountTokenSnapshotLogQueryHandler()),
        accountTokenSnapshotLogs: list(builder, new AccountTokenSnapshotLogQueryHandler()),
        index: get(builder, new IndexQueryHandler()),
        indexes: list(builder, new IndexQueryHandler()),
        indexSubscription: get(builder, new IndexSubscriptionQueryHandler()),
        indexSubscriptions: list(builder, new IndexSubscriptionQueryHandler()),
        stream: get(builder, new StreamQueryHandler()),
        streams: list(builder, new StreamQueryHandler()),
        streamPeriod: get(builder, new StreamPeriodQueryHandler()),
        streamPeriods: list(builder, new StreamPeriodQueryHandler()),
        token: get(builder, new TokenQueryHandler(), CacheTime.ThreeMinutes),
        tokens: list(builder, new TokenQueryHandler()),
        tokenStatistic: get(builder, new TokenStatisticQueryHandler()),
        tokenStatistics: list(builder, new TokenStatisticQueryHandler()),
        tokenStatisticLog: get(builder, new TokenStatisticLogQueryHandler()),
        tokenStatisticLogs: list(builder, new TokenStatisticLogQueryHandler()),
        flowOperator: get(builder, new FlowOperatorQueryHandler()),
        flowOperators: list(builder, new FlowOperatorQueryHandler()),
    };
};
/**
 * Creates "get" endpoint.
 */
function get(builder, queryHandler, cacheTime) {
    return builder.query({
        queryFn: async (arg) => {
            const subgraphClient = await getSubgraphClient(arg.chainId);
            return {
                data: await queryHandler.get(subgraphClient, arg),
            };
        },
        providesTags: (result, _error, arg) => [
            ...createGeneralTags({ chainId: arg.chainId }),
            ...provideSpecificCacheTagsFromRelevantAddresses(arg.chainId, queryHandler.getRelevantAddressesFromResult(result)),
        ],
        keepUnusedDataFor: cacheTime !== null && cacheTime !== void 0 ? cacheTime : CacheTime.OneMinute,
    });
}
/**
 * Creates "list" endpoint.
 */
function list(builder, queryHandler, cacheTime) {
    return builder.query({
        queryFn: async (arg) => {
            const subgraphClient = await getSubgraphClient(arg.chainId);
            return {
                data: await queryHandler.list(subgraphClient, arg),
            };
        },
        providesTags: (_result, _error, arg) => [
            ...createGeneralTags({ chainId: arg.chainId }),
            ...provideSpecificCacheTagsFromRelevantAddresses(arg.chainId, queryHandler.getRelevantAddressesFromFilter(arg.filter)),
        ],
        keepUnusedDataFor: cacheTime !== null && cacheTime !== void 0 ? cacheTime : CacheTime.OneMinute,
    });
}
//# sourceMappingURL=entityEndpoints.js.map